import SegmentedControl from "./SegmentedControl";

export default SegmentedControl;

export * from "./SegmentedControl";
